import { render, staticRenderFns } from "./CpuSoftwareDetailModal.vue?vue&type=template&id=f012145e&scoped=true"
import script from "./CpuSoftwareDetailModal.vue?vue&type=script&lang=js"
export * from "./CpuSoftwareDetailModal.vue?vue&type=script&lang=js"
import style0 from "./CpuSoftwareDetailModal.vue?vue&type=style&index=0&id=f012145e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f012145e",
  null
  
)

export default component.exports